<nav aria-label="breadcrumb" *ngIf="breadcrumbs?.length">
  <ol class="breadcrumb px-5 pt-6 pb-0 xl:px-15 xxl:px-20">
    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      class="breadcrumb-item break-word"
      [ngClass]="{ active: last }"
    >
      <a class="text-decoration-none" *ngIf="!last; else lastItem" [routerLink]="breadcrumb.path">{{
        breadcrumb.label | async
      }}</a>
      <ng-template #lastItem>{{ breadcrumb.label | async }}</ng-template>
    </li>
  </ol>
</nav>
